module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/theme/demo2025/ortho-field-config-translation.json
// module id = 1255
// module chunks = 0